import template from './order-status-selector.html';

const mapStateToThis = ({ dictionary }) => {
  const { orderStatuses } = dictionary;

  return {
    orderStatuses,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class OrderStatusSelectorController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class OrderStatusSelectorComponent {
  constructor() {
    this.controller = OrderStatusSelectorController;
    this.template = template;
    this.bindings = {
      orderStatus: '=',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/order-status-selector/order-status-selector-component.js